import { render, staticRenderFns } from "./seats.vue?vue&type=template&id=6e300d35&scoped=true"
import script from "./seats.vue?vue&type=script&lang=js"
export * from "./seats.vue?vue&type=script&lang=js"
import style0 from "./seats.vue?vue&type=style&index=0&id=6e300d35&lang=scss"
import style1 from "./seats.vue?vue&type=style&index=1&id=6e300d35&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e300d35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e300d35')) {
      api.createRecord('6e300d35', component.options)
    } else {
      api.reload('6e300d35', component.options)
    }
    module.hot.accept("./seats.vue?vue&type=template&id=6e300d35&scoped=true", function () {
      api.rerender('6e300d35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/call/page/seats.vue"
export default component.exports